import { render, staticRenderFns } from "./BackgroundColor.vue?vue&type=template&id=3b5cee6b&scoped=true&"
import script from "./BackgroundColor.vue?vue&type=script&lang=js&"
export * from "./BackgroundColor.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundColor.vue?vue&type=style&index=0&id=3b5cee6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5cee6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5cee6b')) {
      api.createRecord('3b5cee6b', component.options)
    } else {
      api.reload('3b5cee6b', component.options)
    }
    module.hot.accept("./BackgroundColor.vue?vue&type=template&id=3b5cee6b&scoped=true&", function () {
      api.rerender('3b5cee6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/BackgroundColor.vue"
export default component.exports